<template>
  <div class="entries-carousel-container">
    <div
      v-if="currentIndex !== 0"
      class="entries-carousel-button entries-carousel-button__left"
      :class="{ 'entries-carousel-button__light': isLight }"
      @click="scrollLeft()"
    >
      {{ BTN_LEFT }}
    </div>
    <div class="entries-carousel" :style="carouselStyle">
      <StoreItemCard
        v-for="item in items"
        :key="item.id"
        :item="item"
        :is-light="isLight"
        class="entries-carousel-item"
      />
      <div
        v-if="totalCount > 4"
        class="all-card"
        :class="{ 'all-card__light': isLight }"
        @click="previewAll()"
      >
        {{ $vueTranslate('store_items.preview_store_item.view_all') }}
      </div>
    </div>
    <div
      v-if="currentIndex !== items.length - getSkip() && items.length > 3"
      class="entries-carousel-button entries-carousel-button__right"
      :class="{ 'entries-carousel-button__light': isLight }"
      @click="scrollRight()"
    >
      {{ BTN_RIGHT }}
    </div>
  </div>
</template>

<script>
import StoreItemCard from './StoreItemCard'
import { EMITTERS } from '../../shared/utils/emitters'

export default {
  name: 'EntriesCarousel',
  components: { StoreItemCard },
  props: {
    items: {
      default: () => [],
      type: Array,
      required: true,
    },
    totalCount: {
      default: 0,
      type: Number,
      required: true,
    },
    isLight: {
      default: true,
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      BTN_LEFT: '<',
      BTN_RIGHT: '>',
      skip: 3,
      currentIndex: 0,
      translateX: 0,
    }
  },
  computed: {
    carouselStyle() {
      return {
        transform: `translateX(${this.translateX}px)`,
      }
    },
  },
  watch: {
    currentIndex(newIndex) {
      if (newIndex < 0) {
        this.currentIndex = 0
      } else if (newIndex > this.items.length - this.getSkip()) {
        this.currentIndex = this.items.length - this.getSkip()
      }
    },
  },
  methods: {
    previewAll() {
      this.$emit(EMITTERS.STORE_ITEM_PREVIEW_ALL)
    },
    scrollLeft() {
      if (this.currentIndex > 0) {
        this.currentIndex--
        this.translateX += this.getJumpSize()
      }
    },
    scrollRight() {
      if (this.currentIndex < this.items.length - this.getSkip()) {
        this.currentIndex++
        this.translateX -= this.getJumpSize()
      }
    },
    getJumpSize() {
      return this.getItemWidth() + this.getJumpByWidth()
    },
    getJumpByWidth() {
      const width = document.body.clientWidth

      if (width <= 991) return 64

      return 32
    },
    getSkip() {
      const width = document.body.clientWidth

      if (width <= 991) return 1

      return 3
    },
    getItemWidth() {
      return this.$el.querySelector('.entries-carousel-item').offsetWidth
    },
  },
}
</script>

<style lang="scss" scoped>
.entries-carousel-container {
  width: 100%;
  overflow: hidden;
  position: relative;
  margin: 20px 0;
}

.entries-carousel {
  display: flex;
  flex-wrap: nowrap;
  transition: transform 0.3s ease-in-out;
  gap: 29px;
}

.entries-carousel-item {
  flex: 0 0 auto;
  width: calc((100% - 60px) / 3);
  max-width: 270px;
  min-width: 200px;
}

.entries-carousel-button {
  position: absolute;
  display: flex;
  cursor: pointer;
  width: 64px;
  height: 140px;
  top: 0;
  padding: 50px 22px;
  font-size: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: #ffffff;
  background: rgba(11, 9, 15, 0.8);
  box-shadow: 0 4px 40px 0 rgba(167, 167, 167, 0.15);
  z-index: 10;
}

.entries-carousel-button__left {
  left: 0;
}

.entries-carousel-button__right {
  right: 0;
}

.entries-carousel-button__light {
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(4px);
  color: #131118;

  &:hover {
    background: rgba(255, 255, 255, 0.7);
  }
}

.all-card {
  flex: 0 0 24%;
  min-width: 200px;
  max-width: 260px;
  height: 140px;
  background-color: #32303c;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 128%;
}

.all-card__light {
  background-color: #8f8a9b;
}
</style>
